import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  margin: 3rem auto;
  gap: 2rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border: 1px solid #4b286d;
  background: #f2eff4;
  padding: 3rem 5rem;
  border-radius: 1rem;
`;

export const InputContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2rem;
  padding: 1rem 0;
`;

export const Input = styled.input`
  border: 1px solid #4b286d !important;
  border-radius: 0.25rem !important;
  text-align: center;
  height: 0;
  font-weight: 900;
  font-size: 28px;
`;

export const Button = styled.button`
  border-width: 0;
  border-radius: 4px;
  word-wrap: break-word;
  font-size: 1rem;
  letter-spacing: -0.8px;
  line-height: 1.5;
  word-wrap: break-word;
  font-weight: 700;
  height: 3.25rem;
  margin: 0;
  padding: 0 2rem;
  cursor: pointer;
  background: none;
  transition: background 0.2s;
  display: flex;
  width: 30%;
  align-items: center;
  justify-content: center;
  background-color: #2b8000 !important;
  opacity: ${props => (props.isDisabled ? '0.6' : '1')};
  cursor: ${props => (props.isDisabled ? 'not-allowed' : 'pointer')};
  color: #fff;

  &:hover {
    border: 1px solid #2b8000;
    background-color: #fff;
  }
`;
